import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VuexPersist from "vuex-persist";

// Instructions for persisting vuex state to localstorage
// https://flaviocopes.com/vuex-persist-localstorage/
const vuexPersist = new VuexPersist({
  key: "my-app",
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    logintimestampint: 0,
    user: {
      christianname: "",
      email: "",
      familyname: "",
      givenname: "",
      homephone: "",
      isactivated: false,
      isadmin: false,
      membershipstatus: "",
      phone: "",
      preferredname: "",
      title: "",
      username: "",
      uuid: "",
      verified: false
    }
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      state.user = payload.user;
      state.logintimestampint = Date.now();
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.logintimestampint = 0;
      state.user = {
        christianname: "",
        email: "",
        familyname: "",
        givenname: "",
        homephone: "",
        isactivated: false,
        isadmin: false,
        membershipstatus: "",
        phone: "",
        preferredname: "",
        title: "",
        username: "",
        uuid: "",
        verified: false
      };
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/api/user/login",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.id_token;
            const userInfo = resp.data.user;
            localStorage.setItem("id_token", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            let payload = {
              user: userInfo,
              token: token
            };
            commit("auth_success", payload);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "/api/user/signup",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.id_token;
            const userInfo = resp.data.user;
            localStorage.setItem("id_token", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            let payload = {
              user: userInfo,
              token: token
            };
            commit("auth_success", payload);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error", err);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("my-app");
      delete axios.defaults.headers.common["Authorization"];
      // return new Promise((resolve, NULL) => {
      //   commit('logout')
      //   localStorage.removeItem('token')
      //   delete axios.defaults.headers.common['Authorization']
      //   resolve()
      // })
    }
  },
  getters: {
    isAdmin: state => {
      return state.user && state.user.isadmin;
    },
    isActivated: state => {
      return state.user && state.user.isactivated;
    },
    isVerified: state => {
      return state.user && state.user.verified;
    },
    isMember: state => {
      return (
        state.user.membershipstatus == "Infant baptised and reaffirmed" ||
        state.user.membershipstatus == "Adult baptised in Life BPC" ||
        state.user.membershipstatus == "Transferred into Life BPC" ||
        state.user.membershipstatus == "Associate Member"
      );
    },
    isCampOnly: state => {
      return state.user.membershipstatus == "Camp-Only";
    },
    isSeminarOnly: state => {
      return state.user.membershipstatus == "Seminar-Only";
    },
    isADSS: state => {
      return state.user.membershipstatus == "Adult-Sunday-School";
    },
    isLoggedIn: state => {
      return !!state.token;
    },
    authStatus: state => {
      return state.status;
    },
    getUser: state => {
      return state.user;
    },
    getTimestamp: state => {
      return state.logintimestampint;
    }
  }
});
